<template>
  <div
    class="splide"
    :js-carousel="uuid"
  >
    <div class="splide__track">
      <ul class="splide__list">
        <template
          v-for="item in items"
          :key="item.attribute"
        >
          <template
            v-for="refinement in item.refinements"
            :key="[
              refinement.attribute,
              refinement.type,
              refinement.value,
              refinement.operator
            ].join(':')"
          >
            <div
              class="algolia-filters-slider__tags splide__slide"
            >
              <algolia-active-value-tag
                :id="refinement.label"
                :refinement="refinement"
                :tabindex="0"
                @click="item.refine(refinement)"
              />
            </div>
          </template>
        </template>

        <ais-clear-refinements
          :class-names="{
            'ais-ClearRefinements': 'splide__slide',
          }"
        >
          <template #default="{ canRefine, refine }">
            <btn
              v-show="canRefine"
              class="algolia-filters-slider__clear-all"
              :label="$string('collection.clear_all')"
              @click.prevent="refine"
            />
          </template>
        </ais-clear-refinements>
      </ul>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Algolia filters slider (algolia-filters-slider)
 * -----------------------------------------------------------------------------
 * Slider for Algolia filters.
 *
 *
 */
import { AisClearRefinements } from 'vue-instantsearch/vue3/es'
import AlgoliaActiveValueTag from '~async/main-collection/algolia-active-value-tag'
import Carousel from '~/api/carousel'

import { generateUUID } from '~/helpers/general'


export default {
  name: 'AlgoliaFiltersSlider',

  components: {
    AlgoliaActiveValueTag,
    AisClearRefinements,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      uuid: null,
    }
  },

  watch: {
    items() {
      this.createCarousel()
    },
  },

  mounted() {
    this.uuid = generateUUID()

    this.$nextTick(() => {
      this.createCarousel()
    })
  },

  methods: {
    createCarousel() {
      const carousel = Carousel(
        `[js-carousel="${this.uuid}"]`,
        {
          type: 'slide',
          gap: 8,
          drag: true,
          autoWidth: true,
          padding: {
            left: 'var(--margin-desktop)',
            right: 'var(--margin-desktop)',
          },
          breakpoints: {
            640: {
              padding: {
                left: 'var(--margin-mobile)',
                right: 'var(--margin-mobile)',
              },
            },
          },
        },
      )

      carousel.mount()
    },
  },
}
</script>
